import { inject, Injectable } from "@angular/core";
import { TypeFactoryService } from "@wms/services";
import { initial } from "lodash-es";

@Injectable()
export class WidgetDesignerComponent {
  private typeService: TypeFactoryService;
  constructor() {
    this.typeService = inject(TypeFactoryService);
  }

  /**
   * to fetch all the columns for an entity
   */
  getCriteriaFilterFields = (type: any) => {
    return this.typeService.getFieldsForType(type, { 'filter': 'terminal', 'getFieldInfo': true });
  };

  getTypeForTheEntity = (variable: any, entityName: string) => {
    return initial(variable.package.split(".")).join(".") + "." + entityName;
  };

  // This function is used to get the groupby idsplay options.
  getGroupbyDisplayOptions = (fieldArray: any) => {
    let optionObjects = [],
      defaultOptions = [],
      optionCategoryName = 'Field';

    // default options for live list
    defaultOptions = [{ "name": "Javascript", "category": "Script" }];
    optionObjects = defaultOptions;
    fieldArray.forEach((option: any) => {
      optionObjects.push({
        'category': optionCategoryName,
        'name': option
      });
    });
    return optionObjects;
  }

}
